<script setup lang="ts">
import { computed, onMounted } from 'vue'
import { Toaster } from '@/components/ui/toast'
import { http } from '@/services/http.service'
import { useConfigStore } from '@/stores/config.store'
import { useDataStore } from '@/stores/data.store'

const configStore = useConfigStore()
const companyStore = useDataStore()
const companyId = computed(() => companyStore.company)
async function getCompany() {
  if (companyId.value) {
    const response = await http.get(`/companies/${companyId.value}`)
    configStore.hydrateTheme(response.data.theme_color, response.data.theme_radius)
  }
}

onMounted(() => {
  getCompany()
})
watch(companyId, () => {
  getCompany()
})
</script>

<template>
  <slot />
  <Toaster />
</template>
